export enum CELL_RENDERER {
  select_renderer = 'selectRenderer',
  custom_select_renderer = 'customSelectRenderer',
  popover_renderer = 'popoverRenderer',
  nameId_renderer = 'nameIdRenderer'
}
